import React, { useState, useEffect, useRef } from "react";
import { Box, Checkbox, Typography } from "@mui/material";
import Button from "../../components/inputs/Button";
import Textfield from "../../components/inputs/Textfield";
import MobileTopBar from "../../components/navigation/MobileTopBar";
import ProfileIcon from "../../components/icons/ProfileIcon";
import PasswordIcon from "../../components/icons/PasswordIcon";
import EmailIcon from "../../components/icons/EmailIcon";
import CalendarIcon from "../../components/icons/CalendarIcon";
import PhoneIcon from "../../components/icons/PhoneIcon";
import CardIcon from "../../components/icons/CardIcon";
import DropDown from "../../components/inputs/DropDown";
import PaymentCard from "../../components/cards/PaymentCard";
import PlanCard from "../../components/cards/PlanCard";
import api from "../../components/api";

const Home = ({ setState, mobile, state }) => {
  const [name, setName] = useState("");
  const nameRef = useRef();
  const [lastName, setLastName] = useState("");
  const lastNameRef = useRef();
  const [email, setEmail] = useState("");
  const emailRef = useRef();
  const [password, setPassword] = useState("");
  const passwordRef = useRef();
  const [dni, setDni] = useState("");
  const dniRef = useRef();
  const [birthDate, setBirthdate] = useState("");
  const birthdateRef = useRef();
  const [gender, setGender] = useState("");
  const genderRef = useRef();
  const [phone, setPhone] = useState("");
  const phoneRef = useRef();
  const [cardNumber, setCardNumber] = useState("");
  const cardNumberRef = useRef();
  const [expiry, setExpiry] = useState("");
  const expiryRef = useRef();
  const [cardFocused, setCardFocus] = useState(false);
  const [planSelected, setPlanSelected] = useState(0);
  const [planSelectedIndex, setPlanSelectedIndex] = useState(0);
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [user, setUser] = useState("");
  const [error, setError] = useState({});

  const [loading, setLoading] = useState(false);
  const [subscriptionPlans, setSubscriptionPlans] = useState([]);

  const getSubscriptionPlans = async () => {
    setLoading(true);
    await api.getSubscriptionPlans(
      (response) => {
        setLoading(false);
        setSubscriptionPlans(response);
        setPlanSelected(response[0]);
      },
      (error) => {
        setLoading(false);
        console.log(error);
      }
    );
  };

  const registerUser = async () => {
    setLoading(true);
    const birthDateArray = birthDate.split("/");
    const birthDateFormatted = `${birthDateArray[2]}-${birthDateArray[1]}-${birthDateArray[0]}`;
    const genderFormatted = gender == "Hombre" ? "MALE" : gender == "Mujer" ? "FEMALE" : "OTHER";
    const body = {
      name,
      lastName,
      email,
      password,
      dni,
      birthDate: birthDateFormatted,
      gender: genderFormatted,
      phone,
    };
    await api.registerUser(
      body,
      (response) => {
        setUser(response);
        setLoading(false);
        localStorage.setItem("fullpass_user", JSON.stringify(response));
        setState(4);
      },
      (error) => {
        console.log(error);
        setLoading(false);
        if (error.status == 409) {
          alert("Usuario ya registrado");
          setState(1);
        } else {
          alert("Error al registrar usuario");
        }
      }
    );
  };

  const validateCard = () => {
    let errors = {};
    if (expiry.length < 5) {
      errors.expiry = true;
      errors.msg = "Fecha de vencimiento inválida";
    }
    if (
      !validateCardNumber(cardNumber) ||
      (getCardType(cardNumber) == "amex" ? cardNumber.length != 15 : cardNumber.length != 16)
    ) {
      errors.cardNumber = true;
      errors.msg = "Número de tarjeta inválido";
    }

    setError(errors);
    if (Object.keys(errors).length == 0) registerPaymentCard();
  };

  const getCardType = (cardNumber) => {
    if (/^3[47]/.test(cardNumber)) {
      return "amex";
    } else if (/^4/.test(cardNumber)) {
      return "visa";
    } else {
      return "default";
    }
  };

  const validateCardNumber = (cardNumber) => {
    cardNumber = cardNumber.replace(/\s+/g, "");
    if (!/^\d+$/.test(cardNumber)) {
      return false;
    }

    let sum = 0;
    let alternate = false;

    for (let i = cardNumber.length - 1; i >= 0; i--) {
      let digit = parseInt(cardNumber[i], 10);

      if (alternate) {
        digit *= 2;
        if (digit > 9) {
          digit -= 9;
        }
      }

      sum += digit;
      alternate = !alternate;
    }

    return sum % 10 === 0;
  };

  const registerPaymentCard = async () => {
    setLoading(true);
    const expiryArray = expiry.split("/");
    const body = {
      cardNumber,
      cardExpMonth: expiryArray[0],
      cardExpYear: expiryArray[1],
      subscriptionPlanId: planSelected.id,
    };
    await api.addUserPaymentCard(
      body,
      (response) => {
        setLoading(false);
        setState(6);
      },
      (error) => {
        console.log(error);
        setLoading(false);
        const errors = {
          cardNumber: true,
          expiry: true,
          msg: "Tarjeta no aceptada. Por favor, intente con otra tarjeta.",
        };
        setError(errors);
      }
    );
  };

  React.useEffect(() => {
    if (!loading) getSubscriptionPlans();
    if (JSON.parse(localStorage.getItem("fullpass_user"))) setUser(JSON.parse(localStorage.getItem("fullpass_user")));
  }, []);

  const validateState2 = () => {
    let errors = {};

    if (!termsAccepted) {
      errors.termsAccepted = true;
      errors.msg = "Debes aceptar los términos y condiciones";
    }
    if (password.length < 6) {
      errors.password = true;
      errors.msg = "La contraseña debe tener al menos 6 caracteres";
    }
    if (!email.includes("@") || !email.includes(".")) {
      errors.email = true;
      errors.msg = "Email inválido";
    }
    if (lastName.length < 2) {
      errors.lastName = true;
      errors.msg = "Apellido inválido";
    }
    if (name.length < 2) {
      errors.name = true;
      errors.msg = "Nombre inválido";
    }
    setError(errors);
    if (Object.keys(errors).length == 0) setState(3);
  };

  const validateState3 = async () => {
    let errors = {};
    if (phone.length < 8) {
      errors.phone = true;
      errors.msg = "Celular inválido";
    }
    if (gender != "Hombre" && gender != "Mujer" && gender != "Otro") {
      errors.gender = true;
      errors.msg = "Seleccione un género";
    }
    if (birthDate.length < 10) {
      errors.birthDate = true;
      errors.msg = "Fecha de nacimiento inválida. Formato de fecha: dd/mm/aaaa. Ejemplo de fecha: 17/05/1995";
    }

    if (dni.length < 6) {
      errors.dni = true;
      errors.msg = "DNI inválido";
    }

    setError(errors);
    if (Object.keys(errors).length == 0) await registerUser();
  };

  function formatNumberWithDots(number) {
    const numberString = number.toString();
    const parts = [];
    for (let i = numberString.length - 1; i >= 0; i -= 3) {
      const part = numberString.substring(Math.max(0, i - 2), i + 1);
      parts.unshift(part);
    }
    return parts.join(".");
  }

  const handleKeyDown = (event, nextRef) => {
    if (event.key === "Enter") {
      event.preventDefault();
      nextRef.current.focus();
    }
  };

  return (
    <>
      {state == 2 && (
        <>
          {!mobile && (
            <Typography
              style={{
                fontWeight: "bold",
                fontSize: "40px",
                color: "white",
                textAlign: "center",
                lineHeight: "1.2",
                marginBottom: "20px",
              }}
            >
              Creá tu cuenta
            </Typography>
          )}
          {mobile > 0 && (
            <MobileTopBar onBack={() => setState(0)} showBack>
              Creá tu cuenta
            </MobileTopBar>
          )}
          {/*mobile > 0 && <div style={{ marginTop: "70px" }} />*/}
          <Textfield
            hint="Nombre"
            startIcon={<ProfileIcon />}
            onChange={(e) => {
              setName(e);
              setError({ ...error, name: false });
            }}
            error={error.name}
            textValue={name}
            inputRef={nameRef}
            onKeyDown={(e) => handleKeyDown(e, lastNameRef)}
            titleCase
          />
          <Textfield
            hint="Apellido"
            startIcon={<ProfileIcon />}
            onChange={(e) => {
              setLastName(e);
              setError({ ...error, lastName: false });
            }}
            error={error.lastName}
            textValue={lastName}
            inputRef={lastNameRef}
            onKeyDown={(e) => handleKeyDown(e, emailRef)}
            titleCase
          />
          <Textfield
            hint="Email"
            startIcon={<EmailIcon />}
            onChange={(e) => {
              setEmail(e);
              setError({ ...error, email: false });
            }}
            error={error.email}
            textValue={email}
            inputRef={emailRef}
            onKeyDown={(e) => handleKeyDown(e, passwordRef)}
          />
          <Textfield
            hint="Contraseña"
            startIcon={<PasswordIcon />}
            passwordMode={true}
            onChange={(e) => {
              setPassword(e);
              setError({ ...error, password: false });
            }}
            error={error.password}
            textValue={password}
            inputRef={passwordRef}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                passwordRef.current.blur();
              }
            }}
          />
          <Box
            style={{
              display: "flex",
              flexDirection: "row",
              width: "100%",
              maxWidth: "400px",
              alignItems: "center",
              justifyContent: "flex-start",
            }}
          >
            <Checkbox
              style={{ color: "#FF9700" }}
              onChange={(e) => setTermsAccepted(e.target.checked)}
              defaultChecked={termsAccepted}
            />
            <Typography
              style={{
                fontWeight: "400",
                fontSize: mobile > 0 ? "15px" : "16px",
                color: "white",
                textAlign: "center",
                lineHeight: "1.2",
              }}
            >
              He leído y acepto los{" "}
              <span
                style={{
                  fontWeight: "500",
                  color: "#FF9700",
                  cursor: "pointer",
                }}
              >
                Términos y Condiciones.
              </span>
            </Typography>
          </Box>
          {error.msg && (
            <Typography
              style={{
                fontWeight: "400",
                fontSize: "18px",
                color: "#FF1F01",
                textAlign: "center",
                lineHeight: "1.2",
                //opacity: loading ? 0.5 : 1,
              }}
            >
              {error.msg}
            </Typography>
          )}
          <Button onClick={validateState2}>Registrarse</Button>
          <Typography
            style={{
              fontWeight: "400",
              fontSize: "18px",
              color: "white",
              textAlign: "center",
              lineHeight: "1.2",
              cursor: "pointer",
            }}
            onClick={() => setState(1)}
          >
            ¿Ya tenés cuenta? <span style={{ fontWeight: "500", color: "#FF9700" }}>Ingresá</span>
          </Typography>
        </>
      )}
      {state == 3 && (
        <>
          {!mobile && (
            <Typography
              style={{
                fontWeight: "bold",
                fontSize: "40px",
                color: "white",
                textAlign: "center",
                lineHeight: "1.2",
              }}
            >
              Ya casi estamos
            </Typography>
          )}
          {mobile > 0 && (
            <MobileTopBar
              onBack={() => {
                setState(2);
                setError({});
              }}
              showBack
            >
              Ya casi estamos
            </MobileTopBar>
          )}
          {/*mobile > 0 && <div style={{ marginTop: "50px" }} />*/}
          <Typography
            style={{
              fontWeight: "500",
              fontSize: "24px",
              color: "white",
              textAlign: "center",
              lineHeight: "1.2",
            }}
          >
            Contanos un poco más de vos.
          </Typography>
          <Textfield
            hint="Número de DNI"
            onlyNumbers
            maxLength={9}
            startIcon={<ProfileIcon />}
            onChange={(e) => {
              setDni(e);
              setError({ ...error, dni: false });
            }}
            error={error.dni}
            textValue={dni}
            inputRef={dniRef}
            onKeyDown={(e) => handleKeyDown(e, birthdateRef)}
          />
          <Textfield
            hint="Nacimiento (día/mes/año)"
            dateMode
            startIcon={<CalendarIcon />}
            onChange={(e) => {
              setBirthdate(e);
              setError({ ...error, birthDate: false });
            }}
            error={error.birthDate}
            textValue={birthDate}
            inputRef={birthdateRef}
            onKeyDown={(e) => handleKeyDown(e, phoneRef)}
          />
          <Textfield
            hint="Celular"
            onlyNumbers
            startIcon={<PhoneIcon />}
            onChange={(e) => {
              setPhone(e);
              setError({ ...error, phone: false });
            }}
            error={error.phone}
            textValue={phone}
            inputRef={phoneRef}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                phoneRef.current.blur();
              }
            }}
          />
          <DropDown
            hint="Género"
            startIcon={<ProfileIcon />}
            options={["Hombre", "Mujer", "Otro"]}
            onChange={(e) => {
              setGender(e);
              setError({ ...error, gender: false });
            }}
            error={error.gender}
            textValue={gender}
          ></DropDown>

          {error.msg && (
            <Typography
              style={{
                fontWeight: "400",
                fontSize: "18px",
                color: "#FF1F01",
                textAlign: "center",
                lineHeight: "1.2",
                //opacity: loading ? 0.5 : 1,
              }}
            >
              {error.msg}
            </Typography>
          )}
          <Button onClick={validateState3} loading={loading}>
            Confirmar
          </Button>
          <Box
            style={{
              display: "flex",
              flexDirection: "row",
              width: "100%",
              maxWidth: "400px",
              alignItems: "center",
              justifyContent: "flex-start",
              visibility: "hidden",
            }}
          >
            <Checkbox style={{ color: "#FF9700" }} />
            <Typography
              style={{
                fontWeight: "400",
                fontSize: "16px",
                color: "white",
                textAlign: "center",
                lineHeight: "1.2",
              }}
            >
              He leído y acepto los{" "}
              <span
                style={{
                  fontWeight: "500",
                  color: "#FF9700",
                  cursor: "pointer",
                }}
              >
                Términos y Condiciones.
              </span>
            </Typography>
          </Box>
        </>
      )}
      {state == 4 && (
        <>
          {!mobile && (
            <Typography
              style={{
                fontWeight: "bold",
                fontSize: "40px",
                color: "white",
                textAlign: "center",
                lineHeight: "1.2",
                marginBottom: "10px",
                marginTop: "30px",
              }}
            >
              Seleccioná tu plan
            </Typography>
          )}
          {mobile > 0 && (
            <MobileTopBar
              onBack={() => {
                setState(3);
                setError({});
              }}
            >
              Seleccioná tu plan
            </MobileTopBar>
          )}
          {/*mobile > 0 && <div style={{ marginTop: "50px" }} />*/}
          <Box
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "15px",
              marginBottom: "20px",
            }}
          >
            {subscriptionPlans.map((plan, index) => (
              <PlanCard
                key={index}
                planName={plan.name}
                planDescription={plan.description}
                planPrice={`$${formatNumberWithDots(plan.price)} /mes`}
                selected={planSelectedIndex == index}
                onClick={() => {
                  setPlanSelected(plan);
                  setPlanSelectedIndex(index);
                }}
              />
            ))}
          </Box>
          <Button onClick={() => setState(5)}>Confirmar</Button>
        </>
      )}
      {state == 5 && (
        <>
          {!mobile && (
            <Typography
              style={{
                fontWeight: "bold",
                fontSize: "40px",
                color: "white",
                textAlign: "center",
                lineHeight: "1.2",
                marginTop: "30px",
              }}
            >
              Método de pago
            </Typography>
          )}
          {mobile > 0 && (
            <MobileTopBar
              onBack={() => {
                setState(4);
                setError({});
              }}
              showBack
            >
              Método de pago
            </MobileTopBar>
          )}
          {/*mobile > 0 && <div style={{ marginTop: "70px" }} />*/}
          <PlanCard
            planName={planSelected.name}
            planPrice={`$${formatNumberWithDots(planSelected.price)} /mes`}
            selected={false}
            noPointer
          />
          <Typography
            style={{
              fontWeight: "500",
              fontSize: "16px",
              color: "white",
              textAlign: "center",
              lineHeight: "1.2",
              maxWidth: "360px",
            }}
          >
            Datos de la tarjeta de crédito
          </Typography>
          <PaymentCard
            number={cardNumber}
            expiry={expiry}
            cvv={null}
            name={`${name} ${lastName}`}
            focus={cardFocused}
          ></PaymentCard>
          <Textfield
            hint="Número de la tarjeta"
            onlyNumbers
            maxLength={16}
            onFocus={() => setCardFocus("number")}
            startIcon={<CardIcon />}
            onChange={(e) => setCardNumber(e)}
            error={error.cardNumber}
          ></Textfield>
          <Textfield
            hint="Vencimiento (MM/AA)"
            expiryMode
            onFocus={() => setCardFocus("expiry")}
            startIcon={<CalendarIcon />}
            onChange={(e) => setExpiry(e)}
            error={error.expiry}
          ></Textfield>
          <Typography
            style={{
              fontWeight: "500",
              fontSize: "16px",
              color: "white",
              textAlign: "center",
              lineHeight: "1.2",
              maxWidth: "360px",
            }}
          >
            La confirmación de la suscripción puede demorar hasta 48hs hábiles.
          </Typography>
          {error.msg && (
            <Typography
              style={{
                fontWeight: "400",
                fontSize: "18px",
                color: "#FF1F01",
                textAlign: "center",
                lineHeight: "1.2",
                //opacity: loading ? 0.5 : 1,
              }}
            >
              {error.msg}
            </Typography>
          )}
          <Button onClick={() => validateCard()} loading={loading} sx={{ marginBottom: mobile > 0 && "30px" }}>
            Finalizar
          </Button>
          {mobile > 0 && <div style={{ width: "100%", height: "10px", color: "rgba(0,0,0,0)" }}>-</div>}
        </>
      )}
      {state == 6 && (
        <>
          <Typography
            style={{
              fontWeight: "bold",
              fontSize: "40px",
              color: "white",
              textAlign: "center",
              lineHeight: "1.2",
              marginTop: "30px",
            }}
          >
            ¡Gracias por unirte a <span style={{ color: "#FF9700" }}>Full Pass</span>!
          </Typography>
          <Typography
            style={{
              fontWeight: "500",
              fontSize: "20px",
              color: "white",
              textAlign: "justify",
              lineHeight: "1.2",
              marginTop: "30px",
            }}
          >
            Estamos procesando tus datos. En menos de 48hs hábiles te notificaremos vía mail la confirmación de tu
            membresía.
          </Typography>
          <Typography
            style={{
              fontWeight: "500",
              fontSize: "20px",
              color: "white",
              textAlign: "justify",
              lineHeight: "1.2",
            }}
          >
            Podrás acceder a los gimnasios de la red Full Pass una vez que tu membresía se encuentre confirmada y
            activa.
          </Typography>

          <Button onClick={() => setState(0)}>Aceptar</Button>
        </>
      )}
    </>
  );
};

export default Home;
